import {messagesService} from "@dv5/api"
import {roundToGrid} from "./gridUtils"

export interface WidgetPosition {
    id: string
    left: number
    top: number
}

export interface WidgetResize {
    id: string
    left: number
    top: number
    width: number
    height: number
}

class CanvasMoveService {
    moveWidgets(canvasId: string, positions: Array<WidgetPosition>, alignToGrid = false) {
        messagesService.send('canvas.move-widgets', {
            canvasId,
            positions: positions.map(position => ({
                id: position.id,
                left: alignToGrid ? roundToGrid(position.left) : position.left,
                top: alignToGrid ? roundToGrid(position.top) : position.top,
            }))
        })
    }

    resizeWidgets(canvasId: string, resizes: Array<WidgetResize>, alignToGrid = false) {
        messagesService.send('canvas.resize-widgets', {
            canvasId,
            widgets: resizes.map(resize => ({
                ...resize,
                left: alignToGrid ? roundToGrid(resize.left) : resize.left,
                top: alignToGrid ? roundToGrid(resize.top) : resize.top,
            }))
        })
    }
}

export const canvasMoveService = new CanvasMoveService()
